import { AdditionalFilter } from './../rulebook/additional-filter';

export class VersionHistoryFilter extends AdditionalFilter {
    id: number;

    constructor() {
        super();
        this.id = 0;
    }
}
